import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// מדידת ביצועים (לא חובה, מגיע עם CRA)
reportWebVitals();

// רישום Service Worker כדי לאפשר PWA
serviceWorkerRegistration.register();
